class GripFinderWizard {
  constructor() {
    this.currentAngleIndex = 0;
    this.selectedAngle = '40';
    this.selectedDifficulties = new Set();

    // Get settings from section (will be injected via data attributes)
    this.collectionHandle = 'hand-holds';
    this.angleFilterKey = 'filter.p.m.custom.board_angle';
    this.difficultyFilterKeyTemplate = 'filter.p.m.custom.{angle}_degree_difficulty';

    this.init();
  }

  init() {
    this.carousel = document.querySelector('.angle-carousel');
    if (!this.carousel) return;

    // Get section settings from data attributes if available
    const section = document.querySelector('.grip-finder-wizard');
    if (section) {
      this.collectionHandle = section.dataset.collection || this.collectionHandle;
      this.angleFilterKey = section.dataset.angleFilter || this.angleFilterKey;
      this.difficultyFilterKeyTemplate = section.dataset.difficultyFilter || this.difficultyFilterKeyTemplate;
    }

    this.track = this.carousel.querySelector('.angle-carousel__track');
    this.items = Array.from(this.carousel.querySelectorAll('.angle-carousel__item'));
    this.prevBtn = this.carousel.querySelector('.angle-carousel__nav--prev');
    this.nextBtn = this.carousel.querySelector('.angle-carousel__nav--next');

    this.difficultyCards = Array.from(document.querySelectorAll('.difficulty-card'));
    this.difficultyInputs = Array.from(document.querySelectorAll('.difficulty-card__input'));
    this.submitBtn = document.querySelector('.grip-finder-wizard__submit');
    this.submitText = document.querySelector('.grip-finder-wizard__submit-text');

    this.setupCarousel();
    this.setupDifficulty();
    this.setupSubmit();
    this.updateNavButtons();
    this.updateSubmitButton();
  }

  setupCarousel() {
    this.prevBtn.addEventListener('click', () => this.navigateCarousel(-1));
    this.nextBtn.addEventListener('click', () => this.navigateCarousel(1));

    // Keyboard navigation
    this.carousel.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') {
        this.navigateCarousel(-1);
      } else if (e.key === 'ArrowRight') {
        this.navigateCarousel(1);
      }
    });

    // Set initial angle
    if (this.items[0]) {
      this.selectedAngle = this.items[0].dataset.angle;
    }
  }

  setupDifficulty() {
    this.difficultyInputs.forEach(input => {
      input.addEventListener('change', (e) => {
        const difficulty = e.target.value;

        if (e.target.checked) {
          this.selectedDifficulties.add(difficulty);
          console.log('Added:', difficulty, '| Set now has:', Array.from(this.selectedDifficulties));
        } else {
          this.selectedDifficulties.delete(difficulty);
          console.log('Removed:', difficulty, '| Set now has:', Array.from(this.selectedDifficulties));
        }

        this.updateSubmitButton();
      });
    });
  }

  setupSubmit() {
    this.submitBtn.addEventListener('click', () => {
      if (this.selectedDifficulties.size === 0) return;

      const url = this.buildFilterURL();
      window.location.href = url;
    });
  }

  navigateCarousel(direction) {
    const newIndex = this.currentAngleIndex + direction;

    if (newIndex < 0 || newIndex >= this.items.length) {
      return;
    }

    // Remove active class from current
    this.items[this.currentAngleIndex].classList.remove('angle-carousel__item--active');

    // Update index
    this.currentAngleIndex = newIndex;

    // Add active class to new
    this.items[this.currentAngleIndex].classList.add('angle-carousel__item--active');

    // Update selected angle
    this.selectedAngle = this.items[this.currentAngleIndex].dataset.angle;

    // Update track position
    this.track.style.transform = `translateX(-${this.currentAngleIndex * 100}%)`;

    this.updateNavButtons();
  }

  updateNavButtons() {
    this.prevBtn.disabled = this.currentAngleIndex === 0;
    this.nextBtn.disabled = this.currentAngleIndex === this.items.length - 1;
  }

  updateSubmitButton() {
    const hasSelections = this.selectedDifficulties.size > 0;
    this.submitBtn.disabled = !hasSelections;
  }

  buildFilterURL() {
    // Build the collection URL with filters
    const baseUrl = `/collections/${this.collectionHandle}`;
    const params = new URLSearchParams();

    // Add difficulty filters
    // Use the angle-specific difficulty filter key
    const difficultyKey = this.difficultyFilterKeyTemplate.replace('{angle}', this.selectedAngle);

    console.log('Building URL with difficulties:', Array.from(this.selectedDifficulties));
    console.log('Using key:', difficultyKey);

    this.selectedDifficulties.forEach(difficulty => {
      console.log('Appending:', difficultyKey, '=', difficulty);
      params.append(difficultyKey, difficulty);
    });

    const finalURL = `${baseUrl}?${params.toString().replace(/%2B/g, '+')}`
    console.log('Final URL:', finalURL);
    return finalURL;
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new GripFinderWizard();
  });
} else {
  new GripFinderWizard();
}
